import { useApiStatusStateApi } from './useApiStatusStateApi';
/**
 * Builds the state for the MessageApiDown component.
 */
export const useApiDownState = ({ apiList, pollingFrequency, }) => {
    const queryList = useApiStatusStateApi({ apiList, pollingFrequency });
    // find any entry where data is undefined
    const appInStartup = queryList.find(api => api.data === undefined) !== undefined;
    //find that there are no entries where data is false
    const apiUp = !queryList.find(api => api.data === false);
    const isLoading = !!queryList.find(api => api.isLoading);
    return {
        appInStartup,
        apiUp,
        isLoading,
    };
};
